import { useEventBus } from '@restify/packages/helpers/bus'
import { type Stores } from './useStores'
import { type ObjectMapped } from '@restify/packages/components/Map/types'

const appBus = useEventBus<{
  'order-modal-update': {
    orderId: string,
    objectId?: string,
  }
  'order-tap': Stores['orders']['Result']
  'table-tap': {
    order: Stores['orders']['Result'] | null,
    object: {
      object: ObjectMapped['object']
      tableVariant: ObjectMapped['tableVariant']
    }
  }
  'promotions-tap': Stores['orders']['Result']
  'promotions-modal-dismiss': void
  'order-modal-dismiss': void,
  'stock-order-tap': {
    id: string
  }
  'app-visible': void
  'app-hidden': void
}>('app')

export default () => appBus